import {FC} from 'react';
import {twMerge} from 'tailwind-merge';

import Amex from './amex';
import Mastercard from './mastercard';
import Visa from './visa';

type Card = 'amex' | 'mastercard' | 'show-all' | 'visa';
type IconCardProps = {
    className?: string;
    icon: Card;
};
const IconCard: FC<IconCardProps> = ({className, icon}) => {
    if (icon === 'show-all') {
        return (
            <div className={twMerge('flex gap-1', className)}>
                <Mastercard />
                <Visa />
                <Amex />
            </div>
        );
    }
    return (
        <div className={className}>
            {icon === 'visa' && <Visa />}
            {icon === 'mastercard' && <Mastercard />}
            {icon === 'amex' && <Amex />}
        </div>
    );
};
export default IconCard;
